import { APP_SCOPE } from '@nx/constants';
import { createLogger } from '@nx/logger/legacy';

const logger = createLogger(APP_SCOPE.query);

export { logger as log };
